import apiClient from "../../client/apiClient"
import { appendQueryParams } from "../../utils"

const BASE = "/student-leave"

// Leave and suspension are date ranges, not statuses. A child on either stays
// ACTIVE — still on the rolls, still counted in the head count, still owes
// fees. Only their attendance for those days is marked differently (L / S).
export type StudentLeave = {
  _id: string
  type: "leave" | "suspension"
  fromDate: string
  toDate: string
  reason: string
  status: "active" | "cancelled"
  daysMarked: number
  createdAt: string
  createdBy?: { firstName?: string; lastName?: string } | null
  // Only present on a branch-wide listing (not a single student's own list) —
  // flattened server-side from the populated student, same shape the Student
  // Status register already uses.
  studentName?: string
  grNumber?: string
}

export const listStudentLeaves = async (params: {
  studentId?: string
  branchId?: string
  type?: string
}): Promise<{ data: StudentLeave[] }> => {
  const res = await apiClient({ method: "GET", url: appendQueryParams(BASE, params) })
  return res.data
}

export const createStudentLeave = async (data: {
  studentId: string
  type: "leave" | "suspension"
  fromDate: string
  toDate: string
  reason?: string
}): Promise<{
  success: boolean
  message: string
  daysMarked: number
  daysSpanned: number
}> => {
  const res = await apiClient({ method: "POST", url: BASE, data })
  return res.data
}

// Removes only the attendance rows this record created — a day marked by hand
// is never swept away with it. The record itself is kept as the explanation.
export const cancelStudentLeave = async (leaveId: string) => {
  const res = await apiClient({ method: "DELETE", url: `${BASE}/${leaveId}` })
  return res.data
}
